@if (loading) {
<div class="as-fixed-loader">
  <ng-lottie width="150px" height="150px" [options]="options"> </ng-lottie>
  <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
    {{ 'GENERAL.loading' | translate }}...
  </mat-label>
</div>
}
<div class="as-recipes-container">
  <section class="as-header">
    <h1>{{ 'RECIPES.alsuperRecipes' | translate }}</h1>
  </section>
  @if (totalRecipes) {
  <div>
    @if (weekRecipe) {
    <section class="as-recipes-cards-container">
      <div class="as-recipe-title">
        <div class="title">
          <h2>{{ 'RECIPES.weekRecipes' | translate }}</h2>
        </div>
        <div class="green-line"></div>
      </div>
      <a [routerLink]="weekRecipe.recipe_url">
        <div
          [lazyLoad]="weekRecipe.recipe_image"
          class="as-week-recipe as-pointer"
        >
          <div class="card">
            <p class="as-font-black-gray as-font-32 as-font-bold title">
              {{ weekRecipe.recipe_title }}
            </p>
            <p class="as-font as-font-blackish as-font-16 subtitle">
              {{ weekRecipe.recipe_description }}
            </p>
            <div class="as-times">
              <div class="tag" [style]="weekRecipe.color">
                <p class="as-font as-font-20 as-font-white">
                  {{ weekRecipe.category_name }}
                </p>
              </div>
              <div class="cont">
                <mat-icon svgIcon="ic-hours-green"></mat-icon>
                <p class="as-font-16 as-font">
                  {{ weekRecipe.recipe_time }} hrs
                </p>
              </div>
              <div class="cont">
                <mat-icon svgIcon="ic-perfil-green"></mat-icon>
                <p class="as-font-16 as-font">
                  {{ weekRecipe.recipe_portions }} porciones
                </p>
              </div>
            </div>
          </div>
        </div>
      </a>
      <a [routerLink]="weekRecipe.recipe_url">
        <div class="card-mobile">
          <p class="as-font-black-gray as-font-32 as-font-bold title">
            {{ weekRecipe.recipe_title }}
          </p>
          <p class="as-font as-font-blackish as-font-16 subtitle">
            {{ weekRecipe.recipe_description }}
          </p>
          <div class="as-times">
            <div class="tag" [style]="weekRecipe.color">
              <p class="as-font as-font-20 as-font-white">
                {{ weekRecipe.category_name }}
              </p>
            </div>
            <div class="cont">
              <mat-icon svgIcon="ic-hours-green"></mat-icon>
              <p class="as-font-16 as-font">{{ weekRecipe.recipe_time }} hrs</p>
            </div>
            <div class="cont">
              <mat-icon svgIcon="ic-perfil-green"></mat-icon>
              <p class="as-font-16 as-font">
                {{ weekRecipe.recipe_portions }} porciones
              </p>
            </div>
          </div>
        </div>
      </a>
    </section>
    }
    <section class="as-header-recipes">
      <form
        autocomplete="off"
        [formGroup]="filterForm"
        class="as-recipes-filters-container"
      >
        <mat-form-field appearance="outline" color="accent">
          <input
            formControlName="search"
            type="text"
            matInput
            placeholder="{{ 'RECIPES.search' | translate }}"
          />
          <mat-icon matSuffix svgIcon="ic-search-green"> </mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline" color="accent">
          <mat-label>{{ 'RECIPES.categories' | translate }}</mat-label>
          <mat-select formControlName="categories" type="text" matInput>
            <mat-option [value]="'all'">
              {{ 'GENERAL.all' | translate }}
            </mat-option>
            @for (item of categories; track item) {
            <mat-option [value]="item.category_id">
              {{ item.category_name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>
    </section>
    @if (newestRecipes.length) {
    <section class="as-recipes-cards-container">
      <div class="as-recipe-title">
        <div class="title">
          <h2>{{ 'RECIPES.newest' | translate }}</h2>
        </div>
        <div class="green-line"></div>
      </div>
      <div class="container">
        @for (item of newestRecipes; track item) {
        <div class="as-recipe-card">
          <a [routerLink]="item.recipe_url">
            <img
              width="285"
              height="145"
              [ngSrc]="item.recipe_image"
              alt="Imagen de receta"
            />
            <div class="content">
              <p class="as-font as-font-16 as-font-blackish">
                {{ item.recipe_title | slice : 0 : 25
                }}{{ item.recipe_title.length > 25 ? '...' : '' }}
              </p>
              <div class="tag" [style]="item.color">
                <p class="as-font as-font-14 as-font-white">
                  {{ item.category_name }}
                </p>
              </div>
            </div>
            <div class="as-recipe-specs">
              <div class="cont">
                <mat-icon svgIcon="ic-hour-white"></mat-icon>
                <p class="as-font-white as-font-14 as-font">
                  {{ item.recipe_time }} hrs
                </p>
              </div>
              <div class="cont">
                <mat-icon svgIcon="ic-food-white"></mat-icon>
                <p class="as-font-white as-font-14 as-font">
                  {{ item.recipe_portions }} porciones
                </p>
              </div>
            </div>
          </a>
        </div>
        }
      </div>
    </section>
    } @if (recommendedRecipes.length) {
    <section class="as-recipes-cards-container">
      <div class="as-recipe-title">
        <div class="title">
          <h2>{{ 'RECIPES.recommended' | translate }}</h2>
        </div>
        <div class="green-line"></div>
      </div>
      <div class="container">
        @for (item of recommendedRecipes; track item) {
        <div class="as-recipe-card">
          <a [routerLink]="item.recipe_url">
            <img
              width="285"
              height="145"
              [ngSrc]="item.recipe_image"
              alt="Imagen de receta"
            />
            <div class="content">
              <p class="as-font as-font-16 as-font-blackish">
                {{ item.recipe_title | slice : 0 : 25
                }}{{ item.recipe_title.length > 25 ? '...' : '' }}
              </p>
              <div class="tag" [style]="item.color">
                <p class="as-font as-font-14 as-font-white">
                  {{ item.category_name }}
                </p>
              </div>
            </div>
            <div class="as-recipe-specs">
              <div class="cont">
                <mat-icon svgIcon="ic-hour-white"></mat-icon>
                <p class="as-font-white as-font-14 as-font">
                  {{ item.recipe_time }} hrs
                </p>
              </div>
              <div class="cont">
                <mat-icon svgIcon="ic-food-white"></mat-icon>
                <p class="as-font-white as-font-14 as-font">
                  {{ item.recipe_portions }} porciones
                </p>
              </div>
            </div>
          </a>
        </div>
        }
      </div>
    </section>
    }
  </div>
  } @else {
  <section class="no-results">
    <mat-icon svgIcon="ic-basket"></mat-icon>
    <p>{{ 'RECIPES.noResults' | translate }}</p>
  </section>
  }
  <ng-template #noResults>
    <section class="no-results">
      <mat-icon svgIcon="ic-basket"></mat-icon>
      <p>{{ 'RECIPES.noResults' | translate }}</p>
    </section>
  </ng-template>
</div>
